export default __webpack_public_path__ + "static/media/2121.bae2f6f1.png";